<template>
  <div>
    <v-container
      class="full-height"
      fluid
    >
      <report-leave-approved-leave-report
        v-if="$hasPermissionTo(['leave report view'])"
        class="mb-2"
      />
      <report-leave-remaining-leave-balance
        v-if="$hasPermissionTo(['leave report view'])"
        class="mb-2"
      />
      <report-leave-subordinates-leave-balance />
    </v-container>
  </div>      
</template>
<script>
 
  export default {
    components: {
      ReportLeaveApprovedLeaveReport: () => import('@/components/report/leave/ApprovedLeaveReport'),
      ReportLeaveRemainingLeaveBalance: () => import('@/components/report/leave/RemainingLeaveBalance'),
      ReportLeaveSubordinatesLeaveBalance: () => import('@/components/report/leave/SubordinatesLeaveBalance'),
    },
  }
</script>
